module.exports = __webpack_public_path__ + "japao.1506dfd04642a895179bf10baa3fa069.jpg";